<template>
    <div>
        <!--
        <b-card  class="card-accent-primary text-center" header="Alexandre Kenji Takamura">
            -->
            <img v-if="hasCustomAvatar" :src="this.userdata.avatar ? (this.userdata.avatar.indexOf('/') > 0 ? '' : this.$store.state.currentUser.remotePath + this.$store.state.currentUser.avatarPath ) + this.userdata.avatar + '?rand=' + this.rand: 'img/noimage.png'" class="circle-img rounded-circle" @click="openModal()" />
            <div v-else class="circle-img rounded-circle avatar-placeholder" @click="openModal()">{{ avatarInitial }}</div>
            <p></p>
            <div><h5>{{ this.userdata.name }}</h5></div>
            <div><h6>{{ this.userdata.jobname }}</h6></div>
            <div>
              <button class="border-0 bg-transparent" @click="openUserModal()"><i class="fa fa-edit fa-lg text-primary" title="Alterar informações do usuário"></i></button>
              <button class="border-0 bg-transparent" @click="openPasswordModal()"><i class="fa fa-lock fa-lg  text-primary" title="Alterar senha"></i></button>
              <button class="border-0 bg-transparent" @click="openPrinterModal()" v-if="this.userdata.accesses && this.userdata.accesses.find(e => e.code == 'SYS_PRINTER')"><i class="fa fa-print fa-lg text-primary" title="Impressoras"></i></button>
              <button class="border-0 bg-transparent" @click="openAccountModal()" v-if="this.userdata.accesses && this.userdata.accesses.find(e => e.code == 'FIN_ACCOUNT')"><i class="fa fa-money fa-lg  text-primary" title="Conta"></i></button>
              <button class="border-0 bg-transparent" @click="openMessageModal()" v-if="this.userdata.accesses && this.userdata.accesses.find(e => e.code == 'SYS_MESSAGE')"><i class="fa fa-comment-o fa-lg  text-primary" title="Enviar mensagem"></i></button>
            </div>

            <!--
            <div><img src="img/star.png" width="32" height="32" /><img src="img/star.png" width="32" height="32" /><img src="img/star.png" width="32" height="32" /><img src="img/star.png" width="32" height="32" /><img src="img/star_disabled.png" width="32" height="32" /></div>
            -->
            
            <div v-if="this.userdata.accesses && this.userdata.accesses.find(e => e.code == 'SYS_GAMIFICATION')">
              <hr>
              <img src="img/coin.png" width="24" height="24" alt="Coins" title="AgulhasNegrasCoins" /> {{ this.userdata.points }}
            </div>
            
            <hr>

            <div><h5>Como está se sentindo hoje?</h5></div>
            <p></p>

            <div class="row d-flex justify-content-center">
                <div class="col-md-5ths col-xs-6" v-for="item in smiley" :key="item.id"> 
                  <div>
                    <div>
                        <img class="img-responsive" :src="((smileySelected && smileySelected.id == item.id) || (smileyOver && smileyOver.id == item.id))? item.icon : item.iconUnselected"
                        @mouseover="overSmiley(item)"
                        @mouseleave="overSmiley(null)"
                        @click="selectSmiley(item)" width="48" height="48" :alt="item.title" :title="item.title">
                    </div>                 
                  </div>
                </div>
            </div>

            <p></p>
            <div>Seja um dos primeiros a nos dizer como se sente. Algumas pessoas já responderam</div>
            <p></p>
            <div>
                <img src="img/avatars/tux-samurai.png" class="rounded-circle" alt="Cinque Terre" width="24" height="24" />
                <img src="img/avatars/batman.png" class="rounded-circle" alt="Cinque Terre" width="24" height="24" />
                <img src="img/avatars/1.jpg" class="rounded-circle" alt="Cinque Terre" width="24" height="24" />
                <p></p>
            </div>

            <div>
                <b-form-textarea
            id="textarea"
            v-model="feeling"
            placeholder="Diga-nos o que te faz se sentir assim..."
            rows="3"
            ></b-form-textarea>

            </div>
            <div><b-button type="submit" size="sm" variant="primary" @click="submitFeeling()"><i class="fa fa-angellist"></i> Enviar Sentimento</b-button></div>
       
        <b-modal
            v-model="passwordModal"
            id="password-modal"
            centered
            hide-footer
            title="Alterar Senha"
            size="lg">

            <b-form @submit.stop.prevent="onSubmit">

              <div class="animated fadeIn">
    
                <password-component></password-component>

              </div>
           
            </b-form>

        </b-modal>

        <b-modal
          v-model="printerModal"
          id="printer-modal"
          centered
          hide-footer
          title="Impressoras"
          size="md">
          <printer-component></printer-component>
        </b-modal>

        <b-modal
          v-model="accountModal"
          id="account-modal"
          hide-footer
          title="Contas"
          size="xl"
          centered
          >
          <account-component :userId="$store.state.currentUser.id"></account-component>
        </b-modal>


        <b-modal
          v-model="messageModal"
          id="message-modal"
          centered
          hide-footer
          title="Enviar Mensagem"
          size="lg">

          <component-user-message></component-user-message>

        </b-modal>

        <b-modal
            v-model="documentModal"
            id="add-attachments-modal"
            centered
            hide-footer
            title="Foto Principal"
            :size="hasImage ? 'lg' : ''">

            <b-form @submit.stop.prevent="onSubmit">

                <div v-if="!hasImage"
                     class="file-drop-area d-flex flex-column align-items-center justify-content-center p-4 mb-3"
                     :class="{ 'file-drop-area-over': dragOver }"
                     @dragover="dragover"
                     @dragleave="dragleave"
                     @drop="drop"
                     @click="$refs.avatarFileInput.click()">
                    <i class="fa fa-cloud-upload fa-2x mb-2 text-muted"></i>
                    <div>Arraste uma imagem aqui ou clique para selecionar</div>
                    <input ref="avatarFileInput" type="file" accept="image/*" class="file-input" @change="onChange">
                </div>

                <div v-if="hasImage" class="cropper-wrapper mb-3">
                    <img ref="cropperImage" :src="imageSrc" alt="Imagem para recorte" @load="initCropper">
                </div>

                <p></p>
                <div class="d-flex mb-3  justify-content-center">
                    <b-button v-if="hasImage" variant="danger" class="ml-3" @click="clearImage">Limpar Imagem</b-button>
                    &nbsp;
                    <b-button :disabled="!hasImage" variant="primary" @click="submitAvatar">Salvar Imagem</b-button>
                </div>

            </b-form>

        </b-modal>


        <b-modal
            v-model="userModal"
            id="user-modal"
            centered
            hide-footer
            size="lg"
            title="Informações do Usuário">

            <div class="animated fadeIn">
    
  <!--
    <b-row>
      <b-col md="12">
  -->
      <b-nav fill>
        <b-nav-item :active="tabInfo=='P'" @click="tabInfo='P'">Dados Pessoais</b-nav-item>
        <b-nav-item :active="tabInfo=='S'" @click="tabInfo='S'">Informações Adicionais</b-nav-item>        
      </b-nav>

      <div v-show="tabInfo=='P'">

        <b-card>
          <!--
          <div slot="header">
            <strong>Dados Pessoais</strong>
          </div>
          -->
          <b-form>
            <b-form-group
            description="Entre com seu nome de usuário"
            label="Usuário"
            label-for="username"
            :label-cols="3"
            :horizontal="true">
            <b-form-input  v-model="userdata.username" id="username" type="text" autocomplete="name" placeholder="Nome do usuário"></b-form-input>
          </b-form-group>          
          <b-form-group
            description="Entre com seu nome completo"
            label="Nome"
            label-for="fullname"
            :label-cols="3"
            :horizontal="true">
            <b-form-input v-model="selectedUser.name" id="fullname" type="text" autocomplete="name" placeholder="Nome completo"></b-form-input>
          </b-form-group>
          <b-form-group
            description="Entre com seu apelido como deseja ser chamado"
            label="Apelido"
            label-for="alias"
            :label-cols="3"
            :horizontal="true">
            <b-form-input v-model="selectedUser.alias" id="alias" type="text" autocomplete="alias" placeholder="Apelido"></b-form-input>
          </b-form-group>
          <b-form-group
            label="Sexo"
            label-for=""
            :label-cols="3"
            :horizontal="true">
            <b-form-radio-group
              id="gender"
              name="gender">
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="gender1" name="gender" v-model="selectedUser.genderId" class="custom-control-input" value="1">
                <label class="custom-control-label" for="gender1">Masculino</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="gender2" name="gender" v-model="selectedUser.genderId" class="custom-control-input" value="2">
                <label class="custom-control-label" for="gender2">Feminino</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="gender3" name="gender" v-model="selectedUser.genderId" class="custom-control-input" value="3">
                <label class="custom-control-label" for="gender3">Indefinido</label>
              </div>
            </b-form-radio-group>
          </b-form-group>
        
          <b-form-group
            label="Data de nascimento"
            label-for="daten"
            :label-cols="3"
            :horizontal="true">
            <b-form-input v-model="selectedUser.daten" type="date" id="daten"></b-form-input>
          </b-form-group>
          <b-form-group
            description="Por favor entre com seu e-mail"
            label="E-mail"
            label-for="email"
            :label-cols="3"
            :horizontal="true">
            <b-form-input v-model="selectedUser.email" id="email" type="email" placeholder="Entre com seu e-mail" autocomplete="email"></b-form-input>
          </b-form-group>

          <b-form-group label="Telefone" 
            description=""
            label-for="phone"
            :label-cols="3"
            :horizontal="true"
          >
            <b-input-group>
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class='fa fa-phone'></i>
                </span>
              </div>
              <masked-input
                type="tel"
                name="phone"
                class="form-control"
                v-model="selectedUser.phone"
                :mask="['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                :guide="true"               
                >
              </masked-input>
            </b-input-group>

         

          </b-form-group>

          <b-form-group label="Ramal" 
            description=""
            label-for="phoneext"
            :label-cols="3"
            :horizontal="true"
          >
            <b-input-group>
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class='fa fa-headphones'></i>
                </span>
              </div>
              <masked-input
                type="tel"
                name="phoneext"
                class="form-control"
                v-model="selectedUser.phoneExt"
                :mask="[ /\d/, /\d/, /\d/, /\d/, /\d/ ]"
                :guide="true"     
                >
              </masked-input>
            </b-input-group>

         
          </b-form-group>

      
  
          <b-form-group
            label="Departamento"
            label-for="department"
            :label-cols="3"
            :horizontal="true">
            <b-form-select id="department"
              v-model="selectedUser.departmentId"
              :plain="true"
              :options="selectDepartmentDDL"
              :value="[null,'c']">
            </b-form-select>
          </b-form-group>


          <b-form-group
            label="Cargo/Função"
            label-for="jobposition"
            :label-cols="3"
            :horizontal="true">
            <b-form-select id="jobposition"
              v-model="selectedUser.jobPositionId"
              :plain="true"
              :options="selectJobPositionDDL"
              :value="[null,'c']">
            </b-form-select>
          </b-form-group>


          <b-row>
            <b-form-group label="Assinatura" 
            description=""
            label-for="signature"
            >
              <quill-editor v-model="selectedUser.signature" :content="userdata.signature" :options="editorSignatureOptions"></quill-editor>
            </b-form-group>
          </b-row>


          <div slot="footer" class="text-right">
            <b-button @click="submitPersonalData()" variant="primary"><i class="fa fa-dot-circle-o"></i> Salvar Dados Pessoais</b-button>
          </div>
          </b-form>
        </b-card>

    </div>        

    <div v-show="tabInfo=='S'">
      <b-card>
        
        <b-form-group
            label="Serviços"
            label-for="service"
            :horizontal="false">
            <textarea v-model="selectedUser.services" class="form-control" id="services" name="body" rows="4" placeholder=""></textarea>
          </b-form-group>

          <b-form-group
            label="Público alvo"
            label-for="targetAudience"
            :horizontal="false">
            <textarea v-model="selectedUser.targetAudience" class="form-control" id="targetAudience" name="body" rows="4" placeholder=""></textarea>
          </b-form-group>

          <b-card header="Redes Sociais" v-if="selectedUser.socialNetworks">
          <user-social-network-component :userId="selectedUser.id"></user-social-network-component>
          </b-card>

          <div slot="footer" class="text-right">
            <b-button @click="submitPersonalData()" variant="primary"><i class="fa fa-dot-circle-o"></i> Salvar Informações Adicionais</b-button>
          </div>

      </b-card>
    </div>
<!--
      </b-col>
      
    </b-row>
-->    


  </div>

        </b-modal>


    </div>
</template>

<script>
import axios from "axios";
import Vue from 'vue'

import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'

import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
import PrinterComponent from './PrinterComponent'
import PasswordComponent from './PasswordComponent'
import AccountComponent from '../finance/AccountComponent.vue'
import UserSocialNetworkComponent from '../sys/UserSocialNetworkComponent.vue'
import ComponentUserMessage from "./ComponentUserMessage.vue";


const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)

/*
Máscara
*/
import MaskedInput from 'vue-text-mask'
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
import { setupCalendar, DatePicker } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'



const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export default {
    name: 'componentUser',
    components: {
      MaskedInput,
      'v-date-picker': DatePicker,
      PrinterComponent,
      PasswordComponent,
      AccountComponent,
      UserSocialNetworkComponent,
      ComponentUserMessage
    },
    data: function() {
        return {
            tabInfo: 'P',

            rand: Date.now(),

            image: null,
            imageSrc: null,
            cropper: null,
            dragOver: false,

            feeling: "",
            passwordModal: false,
            accountModal: false,
            printerModal: false,
            userModal: false,
            documentModal: false,
            messageModal: false,

            selectedUser: { id: null, username: null, name: null, daten: null, phoneExt: null, phone: null },
    
            jobPositionDDL: [],
            departmentDDL: [],

            /*
            userdata: {
                id: "115",
                name: "Adriana Takamura",
                avatar: "img/noimage.png",
                jobname: "Administração",
                points: 300
            },
            */

            editorMessageOptions: {
              placeholder: 'Entre com sua mensagem',
              readonly: false
            },

            editorSignatureOptions: {
              placeholder: 'Entre com sua assinatura',
              readonly: false
            },

            smileyOver: null,
            smileySelected: null,
            smiley: [
              {
                 id: 1,
                 code: "VERY_SAD",
                 icon: "img/smiley_verysad.png",
                 iconUnselected: "img/smiley_verysad_over.png",
                 title: "Muito triste"
              },
              {
                 id: 2,
                 code: "SAD",
                 icon: "img/smiley_sad.png",
                 iconUnselected: "img/smiley_sad_over.png",
                 title: "Triste"
              },
              {
                 id: 3,
                 code: "NORMAL",
                 icon: "img/smiley_neutral.png",
                 iconUnselected: "img/smiley_neutral_over.png",
                 title: "Neutro"
              },
              {
                 id: 4,
                 code: "HAPPY",
                 icon: "img/smiley_happy.png",
                 iconUnselected: "img/smiley_happy_over.png",
                 title: "Feliz"
              },
              {
                 id: 5,
                 code: "VERY_HAPPY",
                 icon: "img/smiley_veryhappy.png",
                 iconUnselected: "img/smiley_veryhappy_over.png",
                 title: "Muito feliz"
              }
            ],
            usermessage: '',
            signature: '',

            
        }
    },
    computed: {

      selectJobPositionDDL: function() {
        var list = [...this.jobPositionDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '' })
        return list
      },

      selectDepartmentDDL: function() {
        var list = [...this.departmentDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '' })
        return list
      },

        userdata() {
          return this.$store.state.currentUser;
        },
        hasImage() {
        return !!this.image;
        },
        hasCustomAvatar() {
          return !!this.userdata.avatar && this.userdata.avatar !== 'img/noimage.png';
        },
        avatarInitial() {
          const name = (this.userdata && this.userdata.name) || '';
          return name.trim().charAt(0).toUpperCase() || '?';
        }
    },
    watch: {
      image(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue) {
            base64Encode(newValue)
              .then(value => {
                this.imageSrc = value;
              })
              .catch(() => {
                this.imageSrc = null;
              });
          } else {
            this.imageSrc = null;
            this.destroyCropper();
          }
        }
      }
    },
    methods: {

      async getJobPosition() {
        var s = this
        var currentUser = this.$store.state.currentUser
        await axios.get(
            this.$store.state.ws_url + "/jobposition/ddl?companyId=" + s.$store.state.config.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          s.jobPositionDDL = resp.data.obj;
        }).catch(function (error) {
          console.log(error);
        });
        
      },
      async getDepartment() {
        var s = this
        var currentUser = this.$store.state.currentUser
        await axios.get(
            this.$store.state.ws_url + "/department/ddl?companyId=" + s.$store.state.config.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            
        ).then(function(resp) {
          s.departmentDDL = resp.data.obj;
        }).catch(function (error) {
          console.log(error);
        })
        
      },
      getCroppedBlob() {
        return new Promise((resolve, reject) => {
          if (!this.cropper) {
            reject(new Error('Nenhuma imagem para recortar'));
            return;
          }
          this.cropper.getCroppedCanvas({ width: 400, height: 400 }).toBlob(blob => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error('Falha ao gerar a imagem recortada'));
            }
          }, 'image/png');
        });
      },
      async saveAvatar(currentUser) {
        var s = this

        let croppedBlob;
        try {
          croppedBlob = await this.getCroppedBlob();
        } catch (error) {
          console.log(error);
          return;
        }

        let formData = new FormData();
        formData.append('companyId', currentUser.companyId)
        formData.append('file', croppedBlob, 'avatar.png')
        formData.append('uid', currentUser.id)
        formData.append('sid', currentUser.sid)

        await axios.post(
            this.$store.state.ws_url + "/user/avatar", formData
        ).then(function(resp) {
          s.rand = Date.now();
          s.userdata.avatar = resp.data.obj;
          s.clearImage();
          s.documentModal=false;
        }).catch(function (error) {
          console.log(error);
        });


      },
      submitAvatar() {
        this.saveAvatar(this.$store.state.currentUser);

      },
      async savePersonalData(userToSave) {
        var s = this;

        //console.log("Salando usuário")
        //console.log(userToSave)
        userToSave["phoneExt"] = userToSave["phoneExt"].replace(/\D/g, '');
        
        await axios.post(
            this.$store.state.ws_url + "/user",
            userToSave
        ).then(
          function() {
            toast ({
              type: VueNotifications.types.success,
              title: 'Informações do Usuário',
              message: 'Obrigado por manter o seu cadastro atualizado.',
              timeout: 3000
            }),
            s.userModal=false;
            s.$store.state.currentUser = userToSave
          }
        ).catch(function (error) {
          console.log(error);
          //s.changePasswordErrorMessage = error.response.data.message;
        });
      
      },
      submitPersonalData() {

        this.savePersonalData(this.selectedUser);
       
      },

      overSmiley(item) {
        this.smileyOver = item
      },
      
      selectSmiley(item) {
        this.smileySelected = item

        toast ({
          type: VueNotifications.types.warn,
          title: 'Sentimento',
          message: 'Me sentindo ' + item.title + ". Diga-nos o que te faz se sentir assim e clique em Enviar Sentimento",
          timeout: 3000
        })

      },

      openAccountModal() {
        this.accountModal = true
      },
      openPrinterModal() {
        this.printerModal = true
      },

      openMessageModal() {
          this.messageModal = true;
      },

      openPasswordModal() {
          this.passwordModal = true;
      },

      openModal() {
        
          this.documentModal=true;
      },

      openUserModal() {
        
        this.selectedUser = { ...this.$store.state.currentUser }
        this.selectedUser["uid"] = this.$store.state.currentUser.id;
        this.selectedUser["sid"] = this.$store.state.currentUser.sid;

        this.getDepartment();
          this.getJobPosition();
          this.userModal=true;
          
      },
      
      handleFile(file) {
          if (!file || file.type.indexOf('image/') !== 0) {
              toast({
                type: VueNotifications.types.error,
                title: 'Foto Principal',
                message: 'Selecione um arquivo de imagem válido.',
                timeout: 3000
              });
              return;
          }
          this.image = file;
      },
      onChange(event) {
          this.handleFile(event.target.files && event.target.files[0]);
          event.target.value = null; // permite selecionar o mesmo arquivo de novo
      },
      dragover(event) {
          event.preventDefault();
          this.dragOver = true;
      },
      dragleave(event) {
          event.preventDefault();
          this.dragOver = false;
      },
      drop(event) {
          event.preventDefault();
          this.dragOver = false;
          this.handleFile(event.dataTransfer.files && event.dataTransfer.files[0]);
      },

      initCropper() {
          this.destroyCropper();
          this.cropper = new Cropper(this.$refs.cropperImage, {
              aspectRatio: 1,
              viewMode: 1,
              dragMode: 'move',
              cropBoxMovable: false,
              cropBoxResizable: false,
              guides: false,
              background: false,
              autoCropArea: 1
          });
      },
      destroyCropper() {
          if (this.cropper) {
              this.cropper.destroy();
              this.cropper = null;
          }
      },

      clearImage() {
        this.destroyCropper();
        this.image = null;
        },

        onSubmit() {
          if (!this.image) {
              alert("Por favor, selecione uma imagem");
              return;
          }

          alert("Form submitted!");
        },

      

      async saveFeeling(currentUser) {
        var s = this
        await axios.post(
            this.$store.state.ws_url + "/user/feeling",
            {
              "userId": currentUser.id,
              "levelCode": this.smileySelected.code,
              "description": this.feeling,
              "uid": currentUser.id,
              "sid": currentUser.sid
            }
        ).then(function(resp) {
          
        }).catch(function (error) {
          console.log(error);
        });

        this.smileySelected = null;
        this.feeling = '';
      },

      submitFeeling() {

        if(this.smileySelected && this.smileySelected.id > 0) {
          this.saveFeeling(this.$store.state.currentUser);
          toast ({
            type: VueNotifications.types.success,
            title: 'Sentimento',
            message: 'Obrigado por compartilhar seu sentimento!',
            timeout: 2000
          });
            
        }
        else {

          toast ({
            type: VueNotifications.types.error,
            title: 'Sentimento',
            message: "Por favor selecione como está se sentindo hoje. Não é necessário justificar seu sentimento. Você pode nos enviar seu sentimentos sempre que desejar.",
            timeout: 3000
          })

        }

      },

      autoCorrectedDatePipe: () => { return createAutoCorrectedDatePipe('mm/dd/yyyy') },
      NumbersOnly(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
  
      
    },
    mounted: function(){
      this.selectedUser = { ...this.$store.state.currentUser }
      this.selectedUser["uid"] = this.$store.state.currentUser.id
      this.selectedUser["sid"] = this.$store.state.currentUser.sid

    }
}

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.circle-img {
  width: 170px;
  height: 170px;
  object-fit: cover;
  overflow: hidden;
}

.avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background-color: #20a8d8;
  color: #fff;
  font-size: 4.5rem;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
}

.upload-img {
  max-width: 300px;
  max-height: 200px;

  /*
  width: 300px;
  height: 300px;
  object-fit: cover;
  overflow: hidden;  
  */
}

div#add-attachments-modal {
    div.modal-dialog {
      transition: max-width 0.3s ease-out, transform 0.3s ease-out;
    }
    .col.file-drop-column {
      flex-shrink: 1;
    }
    div.file-drop-area {
      border: 2px dashed rgba(0, 0, 0, 0.25);
      cursor: pointer;
      transition: border-color 0.2s ease-out, background-color 0.2s ease-out;
      input.file-input {
        position: absolute;
        height: 0;
      }
      &.file-drop-area-over {
        border-color: #20a8d8;
        background-color: rgba(32, 168, 216, 0.08);
      }
    }
  }

.cropper-wrapper {
  max-height: 400px;
  overflow: hidden;
  img {
    display: block;
    max-width: 100%;
  }

  // Máscara circular no preview do recorte, para refletir como fica no avatar
  ::v-deep .cropper-view-box,
  ::v-deep .cropper-face {
    border-radius: 50%;
  }
}


.col-xs-5ths,
.col-sm-5ths,
.col-md-5ths,
.col-lg-5ths {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
}

.col-xs-5ths {
    width: 20%;
    float: left;
}

@media (min-width: 768px) {
    .col-sm-5ths {
        width: 20%;
        float: left;
    }
}

@media (min-width: 992px) {
    .col-md-5ths {
        width: 20%;
        float: left;
    }
}

@media (min-width: 1200px) {
    .col-lg-5ths {
        width: 20%;
        float: left;
    }
}

.ql-editor{
    min-height:200px;
}
</style>
